module.exports = __webpack_public_path__ + "img/sec1_img3.bbace745.png";